import { useMoralis } from "react-moralis";

const useCollectors = () => {
  const { Moralis, user } = useMoralis();
  const account = user.attributes.accounts[0];

  const getRunes = async () => {
    const challengesTable = Moralis.Object.extend("Runes");
    const queryChallenges = new Moralis.Query(challengesTable);

    queryChallenges.equalTo("ethAddress", account);
    let data = await queryChallenges.first();

    if (account && data === undefined) {
      const newUser = new challengesTable();

      newUser.set("ethAddress", account);
      newUser.set("runes", 1000);
      await newUser.save();
      return newUser;
    } else {
      return data;
    }
  };

  const getLeaderBoard = async () => {
    const users = Moralis.Object.extend("Runes");
    const query = new Moralis.Query(users);
    query.descending("runes");
    let data = await query.find();
    data = JSON.parse(JSON.stringify(data));
    data.forEach((e, i) => {
      e.rank = i + 1;
    });
    return data;
  };

  return { getRunes, getLeaderBoard };
};

export default useCollectors;
